import axios from 'axios';
import { getCreatorApiUrl } from '../components/api-urls';
import auth from '../components/auth';

type CreateWebhookParams = {
  influencerId: number;
  trigger: string;
  webhookUrl: string;
};

const createWebhook = async ({
  influencerId,
  trigger,
  webhookUrl,
}: CreateWebhookParams) => {
  const endpoint = getCreatorApiUrl(`/influencers/${influencerId}/webhooks`);

  const token = auth.getToken();

  const { data } = await axios.post(
    endpoint,
    { influencerId, trigger, webhookUrl },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data;
};

const getWebhooks = async ({ influencerId }: { influencerId: number }) => {
  const endpoint = getCreatorApiUrl(`/influencers/${influencerId}/webhooks`);

  const token = auth.getToken();

  const { data } = await axios.get(endpoint, {
    headers: {
      Authorization: token,
    },
  });

  return data;
};

type DeleteWebhookParams = { influencerId: number; webhookId: string };

const deleteWebhook = async ({
  influencerId,
  webhookId,
}: DeleteWebhookParams) => {
  const endpoint = getCreatorApiUrl(
    `/influencers/${influencerId}/webhooks/${webhookId}`,
  );

  const token = auth.getToken();

  const { data } = await axios.delete(endpoint, {
    headers: {
      Authorization: token,
    },
  });

  return data;
};

export const WebhooksApi = { createWebhook, getWebhooks, deleteWebhook };
